module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_purebarre-ac35b91e8c6ff5f6c328e87170739e0a.png";